/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as XrayServersRouteImport } from './routes/xray-servers'
import { Route as XrayOutboundsRouteImport } from './routes/xray-outbounds'
import { Route as XrayInboundsRouteImport } from './routes/xray-inbounds'
import { Route as UsersRouteImport } from './routes/users'
import { Route as TemplatesRouteImport } from './routes/templates'
import { Route as SystemSettingsRouteImport } from './routes/system-settings'
import { Route as SubscriptionRouteImport } from './routes/subscription'
import { Route as SubscribeFilesRouteImport } from './routes/subscribe-files'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as RoutedOutboundsRouteImport } from './routes/routed-outbounds'
import { Route as PackagesRouteImport } from './routes/packages'
import { Route as NodesRouteImport } from './routes/nodes'
import { Route as MigrateFromMmwRouteImport } from './routes/migrate-from-mmw'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GeneratorRouteImport } from './routes/generator'
import { Route as CustomRulesRouteImport } from './routes/custom-rules'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as CertificatesRouteImport } from './routes/certificates'
import { Route as IndexRouteImport } from './routes/index'
import { Route as XrayServersIndexRouteImport } from './routes/xray-servers.index'
import { Route as XrayOutboundsIndexRouteImport } from './routes/xray-outbounds.index'
import { Route as XrayInboundsIndexRouteImport } from './routes/xray-inbounds.index'
import { Route as TemplatesIndexRouteImport } from './routes/templates.index'
import { Route as SubscriptionIndexRouteImport } from './routes/subscription.index'
import { Route as SubscribeFilesIndexRouteImport } from './routes/subscribe-files.index'
import { Route as RoutedOutboundsIndexRouteImport } from './routes/routed-outbounds.index'
import { Route as PackagesIndexRouteImport } from './routes/packages.index'
import { Route as NodesIndexRouteImport } from './routes/nodes.index'
import { Route as MigrateFromMmwIndexRouteImport } from './routes/migrate-from-mmw.index'
import { Route as CustomRulesIndexRouteImport } from './routes/custom-rules.index'
import { Route as CertificatesIndexRouteImport } from './routes/certificates.index'
import { Route as SubscribeFilesCustomRouteImport } from './routes/subscribe-files.custom'

const XrayServersRoute = XrayServersRouteImport.update({
  id: '/xray-servers',
  path: '/xray-servers',
  getParentRoute: () => rootRouteImport,
} as any)
const XrayOutboundsRoute = XrayOutboundsRouteImport.update({
  id: '/xray-outbounds',
  path: '/xray-outbounds',
  getParentRoute: () => rootRouteImport,
} as any)
const XrayInboundsRoute = XrayInboundsRouteImport.update({
  id: '/xray-inbounds',
  path: '/xray-inbounds',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesRoute = TemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemSettingsRoute = SystemSettingsRouteImport.update({
  id: '/system-settings',
  path: '/system-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionRoute = SubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscribeFilesRoute = SubscribeFilesRouteImport.update({
  id: '/subscribe-files',
  path: '/subscribe-files',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const RoutedOutboundsRoute = RoutedOutboundsRouteImport.update({
  id: '/routed-outbounds',
  path: '/routed-outbounds',
  getParentRoute: () => rootRouteImport,
} as any)
const PackagesRoute = PackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => rootRouteImport,
} as any)
const NodesRoute = NodesRouteImport.update({
  id: '/nodes',
  path: '/nodes',
  getParentRoute: () => rootRouteImport,
} as any)
const MigrateFromMmwRoute = MigrateFromMmwRouteImport.update({
  id: '/migrate-from-mmw',
  path: '/migrate-from-mmw',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const GeneratorRoute = GeneratorRouteImport.update({
  id: '/generator',
  path: '/generator',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomRulesRoute = CustomRulesRouteImport.update({
  id: '/custom-rules',
  path: '/custom-rules',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CertificatesRoute = CertificatesRouteImport.update({
  id: '/certificates',
  path: '/certificates',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const XrayServersIndexRoute = XrayServersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => XrayServersRoute,
} as any)
const XrayOutboundsIndexRoute = XrayOutboundsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => XrayOutboundsRoute,
} as any)
const XrayInboundsIndexRoute = XrayInboundsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => XrayInboundsRoute,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TemplatesRoute,
} as any)
const SubscriptionIndexRoute = SubscriptionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SubscriptionRoute,
} as any)
const SubscribeFilesIndexRoute = SubscribeFilesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SubscribeFilesRoute,
} as any)
const RoutedOutboundsIndexRoute = RoutedOutboundsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RoutedOutboundsRoute,
} as any)
const PackagesIndexRoute = PackagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PackagesRoute,
} as any)
const NodesIndexRoute = NodesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => NodesRoute,
} as any)
const MigrateFromMmwIndexRoute = MigrateFromMmwIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MigrateFromMmwRoute,
} as any)
const CustomRulesIndexRoute = CustomRulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CustomRulesRoute,
} as any)
const CertificatesIndexRoute = CertificatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CertificatesRoute,
} as any)
const SubscribeFilesCustomRoute = SubscribeFilesCustomRouteImport.update({
  id: '/custom',
  path: '/custom',
  getParentRoute: () => SubscribeFilesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/certificates': typeof CertificatesRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/custom-rules': typeof CustomRulesRouteWithChildren
  '/generator': typeof GeneratorRoute
  '/login': typeof LoginRoute
  '/migrate-from-mmw': typeof MigrateFromMmwRouteWithChildren
  '/nodes': typeof NodesRouteWithChildren
  '/packages': typeof PackagesRouteWithChildren
  '/routed-outbounds': typeof RoutedOutboundsRouteWithChildren
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/subscribe-files': typeof SubscribeFilesRouteWithChildren
  '/subscription': typeof SubscriptionRouteWithChildren
  '/system-settings': typeof SystemSettingsRoute
  '/templates': typeof TemplatesRouteWithChildren
  '/users': typeof UsersRoute
  '/xray-inbounds': typeof XrayInboundsRouteWithChildren
  '/xray-outbounds': typeof XrayOutboundsRouteWithChildren
  '/xray-servers': typeof XrayServersRouteWithChildren
  '/subscribe-files/custom': typeof SubscribeFilesCustomRoute
  '/certificates/': typeof CertificatesIndexRoute
  '/custom-rules/': typeof CustomRulesIndexRoute
  '/migrate-from-mmw/': typeof MigrateFromMmwIndexRoute
  '/nodes/': typeof NodesIndexRoute
  '/packages/': typeof PackagesIndexRoute
  '/routed-outbounds/': typeof RoutedOutboundsIndexRoute
  '/subscribe-files/': typeof SubscribeFilesIndexRoute
  '/subscription/': typeof SubscriptionIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/xray-inbounds/': typeof XrayInboundsIndexRoute
  '/xray-outbounds/': typeof XrayOutboundsIndexRoute
  '/xray-servers/': typeof XrayServersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/generator': typeof GeneratorRoute
  '/login': typeof LoginRoute
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/system-settings': typeof SystemSettingsRoute
  '/users': typeof UsersRoute
  '/subscribe-files/custom': typeof SubscribeFilesCustomRoute
  '/certificates': typeof CertificatesIndexRoute
  '/custom-rules': typeof CustomRulesIndexRoute
  '/migrate-from-mmw': typeof MigrateFromMmwIndexRoute
  '/nodes': typeof NodesIndexRoute
  '/packages': typeof PackagesIndexRoute
  '/routed-outbounds': typeof RoutedOutboundsIndexRoute
  '/subscribe-files': typeof SubscribeFilesIndexRoute
  '/subscription': typeof SubscriptionIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/xray-inbounds': typeof XrayInboundsIndexRoute
  '/xray-outbounds': typeof XrayOutboundsIndexRoute
  '/xray-servers': typeof XrayServersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/certificates': typeof CertificatesRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/custom-rules': typeof CustomRulesRouteWithChildren
  '/generator': typeof GeneratorRoute
  '/login': typeof LoginRoute
  '/migrate-from-mmw': typeof MigrateFromMmwRouteWithChildren
  '/nodes': typeof NodesRouteWithChildren
  '/packages': typeof PackagesRouteWithChildren
  '/routed-outbounds': typeof RoutedOutboundsRouteWithChildren
  '/rules': typeof RulesRoute
  '/settings': typeof SettingsRoute
  '/subscribe-files': typeof SubscribeFilesRouteWithChildren
  '/subscription': typeof SubscriptionRouteWithChildren
  '/system-settings': typeof SystemSettingsRoute
  '/templates': typeof TemplatesRouteWithChildren
  '/users': typeof UsersRoute
  '/xray-inbounds': typeof XrayInboundsRouteWithChildren
  '/xray-outbounds': typeof XrayOutboundsRouteWithChildren
  '/xray-servers': typeof XrayServersRouteWithChildren
  '/subscribe-files/custom': typeof SubscribeFilesCustomRoute
  '/certificates/': typeof CertificatesIndexRoute
  '/custom-rules/': typeof CustomRulesIndexRoute
  '/migrate-from-mmw/': typeof MigrateFromMmwIndexRoute
  '/nodes/': typeof NodesIndexRoute
  '/packages/': typeof PackagesIndexRoute
  '/routed-outbounds/': typeof RoutedOutboundsIndexRoute
  '/subscribe-files/': typeof SubscribeFilesIndexRoute
  '/subscription/': typeof SubscriptionIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/xray-inbounds/': typeof XrayInboundsIndexRoute
  '/xray-outbounds/': typeof XrayOutboundsIndexRoute
  '/xray-servers/': typeof XrayServersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/certificates'
    | '/change-password'
    | '/custom-rules'
    | '/generator'
    | '/login'
    | '/migrate-from-mmw'
    | '/nodes'
    | '/packages'
    | '/routed-outbounds'
    | '/rules'
    | '/settings'
    | '/subscribe-files'
    | '/subscription'
    | '/system-settings'
    | '/templates'
    | '/users'
    | '/xray-inbounds'
    | '/xray-outbounds'
    | '/xray-servers'
    | '/subscribe-files/custom'
    | '/certificates/'
    | '/custom-rules/'
    | '/migrate-from-mmw/'
    | '/nodes/'
    | '/packages/'
    | '/routed-outbounds/'
    | '/subscribe-files/'
    | '/subscription/'
    | '/templates/'
    | '/xray-inbounds/'
    | '/xray-outbounds/'
    | '/xray-servers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/change-password'
    | '/generator'
    | '/login'
    | '/rules'
    | '/settings'
    | '/system-settings'
    | '/users'
    | '/subscribe-files/custom'
    | '/certificates'
    | '/custom-rules'
    | '/migrate-from-mmw'
    | '/nodes'
    | '/packages'
    | '/routed-outbounds'
    | '/subscribe-files'
    | '/subscription'
    | '/templates'
    | '/xray-inbounds'
    | '/xray-outbounds'
    | '/xray-servers'
  id:
    | '__root__'
    | '/'
    | '/certificates'
    | '/change-password'
    | '/custom-rules'
    | '/generator'
    | '/login'
    | '/migrate-from-mmw'
    | '/nodes'
    | '/packages'
    | '/routed-outbounds'
    | '/rules'
    | '/settings'
    | '/subscribe-files'
    | '/subscription'
    | '/system-settings'
    | '/templates'
    | '/users'
    | '/xray-inbounds'
    | '/xray-outbounds'
    | '/xray-servers'
    | '/subscribe-files/custom'
    | '/certificates/'
    | '/custom-rules/'
    | '/migrate-from-mmw/'
    | '/nodes/'
    | '/packages/'
    | '/routed-outbounds/'
    | '/subscribe-files/'
    | '/subscription/'
    | '/templates/'
    | '/xray-inbounds/'
    | '/xray-outbounds/'
    | '/xray-servers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CertificatesRoute: typeof CertificatesRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  CustomRulesRoute: typeof CustomRulesRouteWithChildren
  GeneratorRoute: typeof GeneratorRoute
  LoginRoute: typeof LoginRoute
  MigrateFromMmwRoute: typeof MigrateFromMmwRouteWithChildren
  NodesRoute: typeof NodesRouteWithChildren
  PackagesRoute: typeof PackagesRouteWithChildren
  RoutedOutboundsRoute: typeof RoutedOutboundsRouteWithChildren
  RulesRoute: typeof RulesRoute
  SettingsRoute: typeof SettingsRoute
  SubscribeFilesRoute: typeof SubscribeFilesRouteWithChildren
  SubscriptionRoute: typeof SubscriptionRouteWithChildren
  SystemSettingsRoute: typeof SystemSettingsRoute
  TemplatesRoute: typeof TemplatesRouteWithChildren
  UsersRoute: typeof UsersRoute
  XrayInboundsRoute: typeof XrayInboundsRouteWithChildren
  XrayOutboundsRoute: typeof XrayOutboundsRouteWithChildren
  XrayServersRoute: typeof XrayServersRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/xray-servers': {
      id: '/xray-servers'
      path: '/xray-servers'
      fullPath: '/xray-servers'
      preLoaderRoute: typeof XrayServersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/xray-outbounds': {
      id: '/xray-outbounds'
      path: '/xray-outbounds'
      fullPath: '/xray-outbounds'
      preLoaderRoute: typeof XrayOutboundsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/xray-inbounds': {
      id: '/xray-inbounds'
      path: '/xray-inbounds'
      fullPath: '/xray-inbounds'
      preLoaderRoute: typeof XrayInboundsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system-settings': {
      id: '/system-settings'
      path: '/system-settings'
      fullPath: '/system-settings'
      preLoaderRoute: typeof SystemSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription': {
      id: '/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof SubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscribe-files': {
      id: '/subscribe-files'
      path: '/subscribe-files'
      fullPath: '/subscribe-files'
      preLoaderRoute: typeof SubscribeFilesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/routed-outbounds': {
      id: '/routed-outbounds'
      path: '/routed-outbounds'
      fullPath: '/routed-outbounds'
      preLoaderRoute: typeof RoutedOutboundsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/packages': {
      id: '/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof PackagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nodes': {
      id: '/nodes'
      path: '/nodes'
      fullPath: '/nodes'
      preLoaderRoute: typeof NodesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/migrate-from-mmw': {
      id: '/migrate-from-mmw'
      path: '/migrate-from-mmw'
      fullPath: '/migrate-from-mmw'
      preLoaderRoute: typeof MigrateFromMmwRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/generator': {
      id: '/generator'
      path: '/generator'
      fullPath: '/generator'
      preLoaderRoute: typeof GeneratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom-rules': {
      id: '/custom-rules'
      path: '/custom-rules'
      fullPath: '/custom-rules'
      preLoaderRoute: typeof CustomRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/certificates': {
      id: '/certificates'
      path: '/certificates'
      fullPath: '/certificates'
      preLoaderRoute: typeof CertificatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/xray-servers/': {
      id: '/xray-servers/'
      path: '/'
      fullPath: '/xray-servers/'
      preLoaderRoute: typeof XrayServersIndexRouteImport
      parentRoute: typeof XrayServersRoute
    }
    '/xray-outbounds/': {
      id: '/xray-outbounds/'
      path: '/'
      fullPath: '/xray-outbounds/'
      preLoaderRoute: typeof XrayOutboundsIndexRouteImport
      parentRoute: typeof XrayOutboundsRoute
    }
    '/xray-inbounds/': {
      id: '/xray-inbounds/'
      path: '/'
      fullPath: '/xray-inbounds/'
      preLoaderRoute: typeof XrayInboundsIndexRouteImport
      parentRoute: typeof XrayInboundsRoute
    }
    '/templates/': {
      id: '/templates/'
      path: '/'
      fullPath: '/templates/'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof TemplatesRoute
    }
    '/subscription/': {
      id: '/subscription/'
      path: '/'
      fullPath: '/subscription/'
      preLoaderRoute: typeof SubscriptionIndexRouteImport
      parentRoute: typeof SubscriptionRoute
    }
    '/subscribe-files/': {
      id: '/subscribe-files/'
      path: '/'
      fullPath: '/subscribe-files/'
      preLoaderRoute: typeof SubscribeFilesIndexRouteImport
      parentRoute: typeof SubscribeFilesRoute
    }
    '/routed-outbounds/': {
      id: '/routed-outbounds/'
      path: '/'
      fullPath: '/routed-outbounds/'
      preLoaderRoute: typeof RoutedOutboundsIndexRouteImport
      parentRoute: typeof RoutedOutboundsRoute
    }
    '/packages/': {
      id: '/packages/'
      path: '/'
      fullPath: '/packages/'
      preLoaderRoute: typeof PackagesIndexRouteImport
      parentRoute: typeof PackagesRoute
    }
    '/nodes/': {
      id: '/nodes/'
      path: '/'
      fullPath: '/nodes/'
      preLoaderRoute: typeof NodesIndexRouteImport
      parentRoute: typeof NodesRoute
    }
    '/migrate-from-mmw/': {
      id: '/migrate-from-mmw/'
      path: '/'
      fullPath: '/migrate-from-mmw/'
      preLoaderRoute: typeof MigrateFromMmwIndexRouteImport
      parentRoute: typeof MigrateFromMmwRoute
    }
    '/custom-rules/': {
      id: '/custom-rules/'
      path: '/'
      fullPath: '/custom-rules/'
      preLoaderRoute: typeof CustomRulesIndexRouteImport
      parentRoute: typeof CustomRulesRoute
    }
    '/certificates/': {
      id: '/certificates/'
      path: '/'
      fullPath: '/certificates/'
      preLoaderRoute: typeof CertificatesIndexRouteImport
      parentRoute: typeof CertificatesRoute
    }
    '/subscribe-files/custom': {
      id: '/subscribe-files/custom'
      path: '/custom'
      fullPath: '/subscribe-files/custom'
      preLoaderRoute: typeof SubscribeFilesCustomRouteImport
      parentRoute: typeof SubscribeFilesRoute
    }
  }
}

interface CertificatesRouteChildren {
  CertificatesIndexRoute: typeof CertificatesIndexRoute
}

const CertificatesRouteChildren: CertificatesRouteChildren = {
  CertificatesIndexRoute: CertificatesIndexRoute,
}

const CertificatesRouteWithChildren = CertificatesRoute._addFileChildren(
  CertificatesRouteChildren,
)

interface CustomRulesRouteChildren {
  CustomRulesIndexRoute: typeof CustomRulesIndexRoute
}

const CustomRulesRouteChildren: CustomRulesRouteChildren = {
  CustomRulesIndexRoute: CustomRulesIndexRoute,
}

const CustomRulesRouteWithChildren = CustomRulesRoute._addFileChildren(
  CustomRulesRouteChildren,
)

interface MigrateFromMmwRouteChildren {
  MigrateFromMmwIndexRoute: typeof MigrateFromMmwIndexRoute
}

const MigrateFromMmwRouteChildren: MigrateFromMmwRouteChildren = {
  MigrateFromMmwIndexRoute: MigrateFromMmwIndexRoute,
}

const MigrateFromMmwRouteWithChildren = MigrateFromMmwRoute._addFileChildren(
  MigrateFromMmwRouteChildren,
)

interface NodesRouteChildren {
  NodesIndexRoute: typeof NodesIndexRoute
}

const NodesRouteChildren: NodesRouteChildren = {
  NodesIndexRoute: NodesIndexRoute,
}

const NodesRouteWithChildren = NodesRoute._addFileChildren(NodesRouteChildren)

interface PackagesRouteChildren {
  PackagesIndexRoute: typeof PackagesIndexRoute
}

const PackagesRouteChildren: PackagesRouteChildren = {
  PackagesIndexRoute: PackagesIndexRoute,
}

const PackagesRouteWithChildren = PackagesRoute._addFileChildren(
  PackagesRouteChildren,
)

interface RoutedOutboundsRouteChildren {
  RoutedOutboundsIndexRoute: typeof RoutedOutboundsIndexRoute
}

const RoutedOutboundsRouteChildren: RoutedOutboundsRouteChildren = {
  RoutedOutboundsIndexRoute: RoutedOutboundsIndexRoute,
}

const RoutedOutboundsRouteWithChildren = RoutedOutboundsRoute._addFileChildren(
  RoutedOutboundsRouteChildren,
)

interface SubscribeFilesRouteChildren {
  SubscribeFilesCustomRoute: typeof SubscribeFilesCustomRoute
  SubscribeFilesIndexRoute: typeof SubscribeFilesIndexRoute
}

const SubscribeFilesRouteChildren: SubscribeFilesRouteChildren = {
  SubscribeFilesCustomRoute: SubscribeFilesCustomRoute,
  SubscribeFilesIndexRoute: SubscribeFilesIndexRoute,
}

const SubscribeFilesRouteWithChildren = SubscribeFilesRoute._addFileChildren(
  SubscribeFilesRouteChildren,
)

interface SubscriptionRouteChildren {
  SubscriptionIndexRoute: typeof SubscriptionIndexRoute
}

const SubscriptionRouteChildren: SubscriptionRouteChildren = {
  SubscriptionIndexRoute: SubscriptionIndexRoute,
}

const SubscriptionRouteWithChildren = SubscriptionRoute._addFileChildren(
  SubscriptionRouteChildren,
)

interface TemplatesRouteChildren {
  TemplatesIndexRoute: typeof TemplatesIndexRoute
}

const TemplatesRouteChildren: TemplatesRouteChildren = {
  TemplatesIndexRoute: TemplatesIndexRoute,
}

const TemplatesRouteWithChildren = TemplatesRoute._addFileChildren(
  TemplatesRouteChildren,
)

interface XrayInboundsRouteChildren {
  XrayInboundsIndexRoute: typeof XrayInboundsIndexRoute
}

const XrayInboundsRouteChildren: XrayInboundsRouteChildren = {
  XrayInboundsIndexRoute: XrayInboundsIndexRoute,
}

const XrayInboundsRouteWithChildren = XrayInboundsRoute._addFileChildren(
  XrayInboundsRouteChildren,
)

interface XrayOutboundsRouteChildren {
  XrayOutboundsIndexRoute: typeof XrayOutboundsIndexRoute
}

const XrayOutboundsRouteChildren: XrayOutboundsRouteChildren = {
  XrayOutboundsIndexRoute: XrayOutboundsIndexRoute,
}

const XrayOutboundsRouteWithChildren = XrayOutboundsRoute._addFileChildren(
  XrayOutboundsRouteChildren,
)

interface XrayServersRouteChildren {
  XrayServersIndexRoute: typeof XrayServersIndexRoute
}

const XrayServersRouteChildren: XrayServersRouteChildren = {
  XrayServersIndexRoute: XrayServersIndexRoute,
}

const XrayServersRouteWithChildren = XrayServersRoute._addFileChildren(
  XrayServersRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CertificatesRoute: CertificatesRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  CustomRulesRoute: CustomRulesRouteWithChildren,
  GeneratorRoute: GeneratorRoute,
  LoginRoute: LoginRoute,
  MigrateFromMmwRoute: MigrateFromMmwRouteWithChildren,
  NodesRoute: NodesRouteWithChildren,
  PackagesRoute: PackagesRouteWithChildren,
  RoutedOutboundsRoute: RoutedOutboundsRouteWithChildren,
  RulesRoute: RulesRoute,
  SettingsRoute: SettingsRoute,
  SubscribeFilesRoute: SubscribeFilesRouteWithChildren,
  SubscriptionRoute: SubscriptionRouteWithChildren,
  SystemSettingsRoute: SystemSettingsRoute,
  TemplatesRoute: TemplatesRouteWithChildren,
  UsersRoute: UsersRoute,
  XrayInboundsRoute: XrayInboundsRouteWithChildren,
  XrayOutboundsRoute: XrayOutboundsRouteWithChildren,
  XrayServersRoute: XrayServersRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
